import React, { useState, useEffect } from 'react'
import './Dashboard.css'
import CalendarView from '../../component/overview/CalendarView'
import RoleMenu from '../../utilities/roleMenu/RoleMenu'
import UserOverview from '../../component/overview/UserOverview'
import 'react-datepicker/dist/react-datepicker.css'
import Spinner from '../../utilities/spinner/Spinner'
//Redux
import { useDispatch, useSelector } from 'react-redux'
import { setTitle, getOverview } from '../../redux'

function Dashboard() {
  const INITIAL_STATE = {
    Pending: 0,
    Due7Days: 0,
  }

  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const document = useSelector((state) => state.document)

  const [pendingDocuments, setPendingDocuments] = useState(null)
  const [docFromYou, setDocFromYou] = useState(INITIAL_STATE)
  const [docToYou, setDocToYou] = useState(INITIAL_STATE)

  useEffect(() => {
    dispatch(setTitle('Dashboard'))
  }, [])

  useEffect(() => {
    if (user.credentials.id) {
      dispatch(getOverview())

      if (document.documents.length > 0) {
        var docToYou = { ...INITIAL_STATE }
        var docFromYou = { ...INITIAL_STATE }
        var myDocuments = []
        const presentDate = new Date()
        document.documents.forEach((doc) => {
          if (doc.status === 'Pending') {
            const dueDate = new Date(doc.dueDate)

            var difference_In_Days = null
            const difference_In_Time = dueDate.getTime() - presentDate.getTime()
            difference_In_Days = difference_In_Time / (1000 * 3600 * 24)
            myDocuments.push({
              id: doc.id,
              title: doc.title,
              dueDate,
            })

            if (doc.sender.id === user.credentials.id) {
              //sent from you
              docFromYou['Pending']++
              if (difference_In_Days && difference_In_Days >= 0 && difference_In_Days <= 7) docFromYou['Due7Days']++
            } else if (doc.receivers.some((receiver) => receiver.id === user.credentials.id)) {
              //sent to you
              docToYou['Pending']++
              if (difference_In_Days && difference_In_Days >= 0 && difference_In_Days <= 7) docToYou['Due7Days']++
            }
          }
        })
        setPendingDocuments(myDocuments)
        setDocFromYou(docFromYou)
        setDocToYou(docToYou)
      } else {
        setDocFromYou({ ...INITIAL_STATE })
        setDocToYou({ ...INITIAL_STATE })
        setPendingDocuments([])
      }
    }
  }, [user.credentials.id, document.documents, document.refresh])

  let dashboardMarkup =
    pendingDocuments && user.credentials.role ? (
      <div className='dashboard-container'>
        <CalendarView pendingDocuments={pendingDocuments} />
        {user.credentials.role === 'Signer' && (
          <div className='dashboard-role-menu'>
            <RoleMenu />
          </div>
        )}
        <UserOverview docFromYou={docFromYou} docToYou={docToYou} role={user.credentials.role} />
      </div>
    ) : (
      <Spinner />
    )

  return dashboardMarkup
}

export default Dashboard
